<div [formGroup]="group" class="address ctn ctn-right sep-right">
    <h2 *ngIf="config.title">{{ config.title }}</h2>

    <text-field class="sep-right" [group]="group" icon="fa fa-map-marker" placeholder="Ville" controlName="city"></text-field>
    <a href="#" class="link link-color" (click)="showMap($event)">{{ config.showMap ? 'Cacher la map' : 'Voir la map' }}</a>
</div>
